const customColors = {
  consumer: "var(--consumer)",
  sustainability: "var(--sustainability)",
  siftedPurple: "var(--siftedPurple)",
  "creative-and-education": "var(--creative-and-education)",
  "corporate-innovation": "var(--corporate-innovation)",
  services: "var(--services)",
  "public-and-academic": "var(--public-and-academic)",
  fintech: "var(--fintech)",
  "venture-capital": "var(--venture-capital)",
  mobility: "var(--mobility)",
  "startup-life": "var(--startup-life)",
  deeptech: "var(--deeptech)",
  healthtech: "var(--healthtech)",
  "dark-blue": "var(--dark-blue)",
  "latest-news": "var(--latest-news)",
  "corporate-innovation2": "var(--corporate-innovation2)",
  services2: "var(--services2)",
  fintech2: "var(--fintech2)",
  "public-and-academic2": "var(--public-and-academic2)",
  mobility2: "var(--mobility2)",
  "startup-life2": "var(--startup-life2)",
  deeptech2: "var(--deeptech2)",
  "venture-capital2": "var(--venture-capital2)",
  "future-proof": "var(--future-proof)",
  other: "var(--other)",
  darkGray: "var(--darkGray)",
  lightGray: "var(--lightGray)",
  pillGray: "var(--pillGray)",
  black: "var(--black)",
  // Design system (2023)
  background: "var(--background)",
  cerise: "#dc085c",
  bigblue: "var(--pro-blue)",
  "bigblue-25": "var(--bigblue-25)",
  "bigblue-50": "var(--bigblue-50)",
  blackrock: "#020231",
  teal: "#387F98",
  salmon: "#EC6458",
  green: "#3B863A",
};

const isValidSectorColor = (slug) => {
  return Object.keys(customColors).includes(slug);
};

module.exports = {
  customColors,
  isValidSectorColor,
};
